<h4 class="mt-0 mb-4 py-3">
  {{ "PRODUCTS.COLLECTION_UNIT.COLLECTION_COMPILATION" | translate }}:
  <mat-icon
    class="collection-info"
    [matTooltip]="'PRODUCTS.COLLECTION_UNIT.TOOLTIP' | translate"
    >info</mat-icon
  >
</h4>

<div [formGroup]="form">
  <ng-container formArrayName="collections">
    <ng-container
      *ngFor="let collection of collections.controls; let groupIndex = index"
    >
      <mat-expansion-panel
        class="initial white"
        [expanded]="openedGroupIndexes.includes(groupIndex)"
        (expandedChange)="openGroup($event, groupIndex)"
      >
        <mat-expansion-panel-header class="initial"
          ><p class="m-0">
            {{ "PRODUCTS.COLLECTION_UNIT.COLLECTION" | translate }}
            {{ groupIndex + 1 }}
          </p></mat-expansion-panel-header
        >

        <div [formGroupName]="groupIndex">
          <ng-container formArrayName="collectionLevels">
            <div
              class="d-flex indent"
              *ngFor="
                let collectionLevel of collectionLevels(groupIndex).controls;
                let i = index;
                let last = last
              "
              [style.--level]="i"
            >
              <app-product-collection-level
                [form]="getCollectorLevel(groupIndex, i)"
                [readOnly]="readOnly"
                [groupIndex]="groupIndex"
                [last]="last"
                [showLevelButtons]="showLevelButtons(groupIndex, i)"
                [parentPackagingUnitId]="
                  getCollectorLevel(groupIndex, i - 1)
                    ? getCollectorLevel(groupIndex, i - 1).value.id
                    : packagingUnitId
                "
                (delete)="deleteLast(groupIndex)"
                (edit)="onEdit(groupIndex, i)"
                (cancelEditing)="cancelEditing($event, groupIndex)"
              ></app-product-collection-level>
            </div>
          </ng-container>
        </div>
        <div class="button-row m-4" *ngIf="!readOnly">
          <button
            type="button"
            mat-stroked-button
            color="primary"
            (click)="addHierarchy(groupIndex)"
            [disabled]="editingGroupIndex === groupIndex"
            *ngIf="collectionLevels(groupIndex).controls.length < 4"
          >
            {{ "PRODUCTS.COLLECTION_UNIT.ADD_HIERARCHY" | translate }}
          </button>
        </div>
      </mat-expansion-panel>
    </ng-container>
  </ng-container>
</div>
<div class="button-row mt-3" *ngIf="!readOnly">
  <button
    type="button"
    class="mt-3"
    mat-stroked-button
    color="primary"
    (click)="addCollection()"
    [disabled]="
      editingGroupIndex === collections.length - 1 &&
      !collectionLevels(collections.length - 1).at(0).value.id
    "
  >
    {{ "PRODUCTS.COLLECTION_UNIT.ADD_COLLECTION" | translate }}
  </button>
</div>
